export default __webpack_public_path__ + "static/media/MobileIcon.ad7e84b6.svg";